import { cn } from "@/lib/utils";
import {
  formatReportingYearPeriod,
  mapYearToReportingPeriod,
} from "@/features/esg/utils/period-constants";
import { toJS } from "mobx";

const splitReportingPeriodLabel = (label = "") => {
  const match = String(label).match(/^(.*?)\s*(\([^)]*\))$/);

  return match
    ? { year: match[1].trim(), period: match[2] }
    : { year: String(label), period: "" };
};

const ReportingPeriodLabel = ({
  label,
  reportingYears = [],
  year,
  month,
  entryValue,
  fallback = "",
  matchMode = "startYear",
  direction = "vertical",
  className,
  yearClassName,
  periodClassName,
  row,
}) => {
  const startYearReportingPeriod = reportingYears.find(
    (reportingYear) => String(reportingYear?.startYear) === String(year),
  );
  const displayLabel = (() => {
    console.log(
      "ReportingPeriodLabel",
      { label, reportingYears, year, month, entryValue, fallback },
      toJS(row),
    );
    if (label != null) return label;
    if (entryValue != null) {
      return mapYearToReportingPeriod(reportingYears, entryValue);
    }
    if (year != null && month != null) {
      return mapYearToReportingPeriod(reportingYears, { year, month });
    }
    if (year != null) {
      if (matchMode === "period") {
        return mapYearToReportingPeriod(reportingYears, year);
      }
      return startYearReportingPeriod
        ? formatReportingYearPeriod(startYearReportingPeriod)
        : String(year);
    }
    return fallback;
  })();
  const { year: yearLabel, period } = splitReportingPeriodLabel(displayLabel);

  return (
    <span
      className={cn(
        "min-w-0",
        direction === "vertical"
          ? "flex flex-col items-baseline"
          : "inline-flex items-baseline gap-1.5",
        className,
      )}
    >
      <span className={cn("truncate", yearClassName)} title={displayLabel}>
        {yearLabel}
      </span>
      {period && (
        <span
          className={cn(
            "text-muted-foreground text-xs shrink-0",
            periodClassName,
          )}
        >
          {period}
        </span>
      )}
    </span>
  );
};

export default ReportingPeriodLabel;
